<!--
 * @Author: your name
 * @Date: 2020-10-09 17:48:42
 * @LastEditTime: 2021-03-23 16:35:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\views\Home\Member\children\Application.vue
-->
<template>
  <div id='application'>

    <el-tabs class="admin_content" v-model="activeName" @tab-click="handleTabClick" v-if="tabIndex==0">
      <el-tab-pane name="1" label="进行中">
        <el-row class="introduction">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="one">
            <img src="@/assets/img/待审批.png" alt=""> 进行中
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="two">
            排序<img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg">
          </el-col>
        </el-row>
        <el-row class="detail" v-for="(item,index) in pendingData" :key="index">
          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="detail_l">
            <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7" class="common left_one">
              <div class="square" style="background-color:#0066cc;"><img src="@/assets/img/申请审批.png" alt=""></div>
              <!-- <div class="square" style="background-color:#ffae00;" v-else-if="item.applyStatus==2"><img src="@/assets/img/申请审批.png" alt=""></div>
              <div class="square" style="background-color:#dd3924;" v-else-if="item.applyStatus==3"><img src="@/assets/img/申请审批.png" alt=""></div> -->
              <div class="text">
                <p v-if="item.applyType==1" style="color:#6a707e;">调查表申请</p>
                <p v-else-if="item.applyType==2" style="color:#6a707e;">产品发布</p>
                <p v-else-if="item.applyType==3" style="color:#6a707e;">申请入会</p>
                <p v-else-if="item.applyType==4" style="color:#6a707e;">资质、补贴及荣誉审核</p>
                <p v-else-if="item.applyType==5" style="color:#6a707e;">企业联系人审核</p>
                <p v-else-if="item.applyType==6" style="color:#6a707e;">缴费凭证审核</p>
                <p v-else-if="item.applyType==7" style="color:#6a707e;">文件审核</p>
                <br />
                <p style="color:#999999;">{{$dayjs(item.updateTime).format("YYYY-MM-DD HH:mm")}} 更新</p>
              </div>

            </el-col>
            <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14" class="common left_two">
              <div class="info">
                <!-- <p style="color:#6a707e;">发起公司名： {{item.companyName}}</p>
                <br /> -->
                <p style="color:#999999;line-height:60px;">发起时间： {{$dayjs(item.createTime).format("YYYY-MM-DD HH:mm")}}</p>
              </div>
            </el-col>
            <!-- <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7" class="common left_three">
              <div class="info">
                &nbsp;
              </div>
            </el-col> -->
            <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3" class="left_four">
              <div class="info quick">
                <!-- <img src="@/assets/img/急.png" alt=""> -->
                <p style="color:#0066cc;" @click="gToQuesNare(item)">详情</p>
                <br />
                <p style="color:#0066cc;" @click="hurryClick">催一下</p>
              </div>
            </el-col>
          </el-col>
          <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="detail_r">
            <!-- <span class="timeOut" v-if="item.applyStatus==2">{{item.soonTimeOut}}</span> -->
            <!-- <span class="timeOut" v-if="item.applyStatus==3">{{item.lastTime}}</span> -->
            <!-- <img src="@/assets/img/问号.png" alt=""> -->
          </el-col>
        </el-row>
        <el-pagination class="one" @current-change="pendingCurrent" :current-page.sync="statusParams.pageNumber" :page-size="statusParams.pageSize" layout="total, prev, pager, next" :total="pendingTotal">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane name="2" label="未通过">
        <el-row class="introduction">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="one">
            <i class="el-icon-warning-outline turnDown"></i> 未通过
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="two">
            排序<img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg">
          </el-col>
        </el-row>
        <el-row class="detail" v-for="(item,index) in turnDownData" :key="index">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="detail_l">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="common left_one">
              <div class="square needApply"><img src="@/assets/img/申请审批.png" alt=""></div>
              <div class="text">
                <p v-if="item.applyType==1" style="color:#6a707e;">调查表申请</p>
                <p v-else-if="item.applyType==2" style="color:#6a707e;">产品发布</p>
                <p v-else-if="item.applyType==3" style="color:#6a707e;">申请入会</p>
                <p v-else-if="item.applyType==4" style="color:#6a707e;">资质、补贴及荣誉审核</p>
                <p v-else-if="item.applyType==5" style="color:#6a707e;">企业联系人审核</p>
                <p v-else-if="item.applyType==6" style="color:#6a707e;">缴费凭证审核</p>
                <p v-else-if="item.applyType==7" style="color:#6a707e;">文件审核</p>
                <br />
                <p style="color:#999999;">{{$dayjs(item.updateTime).format("YYYY-MM-DD HH:mm")}} 更新</p>
              </div>

            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="common left_two">
              <div class="info" style="line-height: 60px;">
                &nbsp;
                <!-- <p style="color:#6a707e;">发起公司名： {{item.companyName}}</p>
                <br /> -->
                <p style="color:#999999;">发起时间{{$dayjs(item.createTime).format("YYYY-MM-DD HH:mm")}}</p>
              </div>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="common left_three">
              <div class="info" style="line-height: 60px;">
                &nbsp;
                <p style="color:#999999;">审批时间：{{$dayjs(item.updateTime).format("YYYY-MM-DD HH:mm")}}</p>
              </div>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="left_four ">
              <div class="info quick" style="text-align:center;">
                <p style="color:rgb(0, 102, 204);margin-bottom:15px;" @click="gToQuesNare(item)">详情</p>
                <!-- <img src="@/assets/img/急.png" alt=""> -->
                <el-popover placement="bottom" width="100" title="原因" trigger="click" popper-class="application" :content="reasonData.comment==''||reasonData.comment==null?'无':reasonData.comment">
                  <el-link slot="reference" style="color:#0066cc;margin-bottom:20px;" @click="reason(item.id)">查看原因</el-link>
                </el-popover>
                <!-- <p style="color:#0066cc;">查看原因</p> -->
                <!-- <br />
                <el-link style="color:#0066cc;">整改</el-link> -->
                <!-- <p style="color:#0066cc;line-height:60px;" v-if="item.applyStatus==5">通过</p>
                <template v-else-if="item.applyStatus==4">
                  <p style="color:#0066cc;">已驳回</p>
                  <br />
                  <el-popover placement="bottom" width="100" title="原因" trigger="click" popper-class="application" :content="reasonData.comment==''||reasonData.comment==null?'无':reasonData.comment">
                    <el-link slot="reference" style="color:#0066cc;" @click="reason(item.id)">查看原因</el-link>
                  </el-popover>
                </template> -->
              </div>
            </el-col>
          </el-col>
          <!-- <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="detail_r">
            <span class="timeOut">{{timeOut?timeOut:'超时时间:无'}}</span>
            <img src="@/assets/img/问号.png" alt="">
          </el-col> -->
        </el-row>
        <el-pagination class="one" @current-change="turnDownCurrent" :current-page.sync="statusParams.pageNumber" :page-size="statusParams.pageSize" layout="total, prev, pager, next" :total="turnDownTotal">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane name="3" label="已通过">
        <el-row class="introduction">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="one">
            <img src="@/assets/img/已完成.png" alt=""> 已通过
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="two">
            排序<img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="handleImg">
          </el-col>
        </el-row>
        <el-row class="detail" v-for="(item,index) in finishedData" :key="index">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="detail_l">
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="common left_one">
              <div class="square finished"><img src="@/assets/img/申请审批.png" alt=""></div>
              <div class="text">
                <p v-if="item.applyType==1" style="color:#6a707e;">调查表申请</p>
                <p v-else-if="item.applyType==2" style="color:#6a707e;">产品发布</p>
                <p v-else-if="item.applyType==3" style="color:#6a707e;">申请入会</p>
                <p v-else-if="item.applyType==4" style="color:#6a707e;">资质、补贴及荣誉审核</p>
                <p v-else-if="item.applyType==5" style="color:#6a707e;">企业联系人审核</p>
                <p v-else-if="item.applyType==6" style="color:#6a707e;">缴费凭证审核</p>
                <p v-else-if="item.applyType==7" style="color:#6a707e;">文件审核</p>
                <!-- <p style="color:#999999;">工作流程描述工作流程描述工作流程...</p> -->
                <p style="color:#999999;">{{$dayjs(item.updateTime).format("YYYY-MM-DD HH:mm")}} 更新</p>
              </div>

            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="common left_two">
              <div class="info" style="line-height: 60px;">
                <!-- <p style="color:#6a707e;">发起公司名： {{item.companyName}}</p>
                <br /> -->
                <p style="color:#999999;">发起时间： {{$dayjs(item.createTime).format("YYYY-MM-DD HH:mm")}}</p>
              </div>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="common left_two">
              <div class="info" style="line-height: 60px;">
                <!-- <p style="color:#6a707e;">发起公司名： {{item.companyName}}</p>
                <br /> -->
                <p style="color:#999999;">完成时间： {{$dayjs(item.updateTime).format("YYYY-MM-DD HH:mm")}}</p>
              </div>
            </el-col>
            <!-- <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7" class="common left_three">
              <div class="info">
                &nbsp;
              </div>
            </el-col> -->
            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="left_four middleY">
              <div class="info quick" style="line-height: 30px;text-align:center;">
                <p style="color:#0066cc;" @click="gToQuesNare(item)">详情</p>
              </div>
            </el-col>
          </el-col>
          <!-- <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="detail_r">
            <span class="timeOut">{{timeOut?timeOut:'超时时间:无'}}</span>
            <img src="@/assets/img/问号.png" alt="">
          </el-col> -->
        </el-row>
        <el-pagination class="one" @current-change="finishedCurrent" :current-page.sync="statusParams.pageNumber" :page-size="statusParams.pageSize" layout="total, prev, pager, next" :total="finishedTotal">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <template v-else-if="tabIndex==1">
      <Questionnaire :quesNaireData="quesNaireData" />
    </template>
    <template v-else-if="tabIndex==4">
      <HonorInfo :quesNaireData="quesNaireData" />
    </template>
    <template v-else-if="tabIndex==5">
      <Contact :quesNaireData="quesNaireData" />
    </template>
    <template v-else-if="tabIndex==6">
      <Payment :quesNaireData="quesNaireData" />
    </template>
    <template v-else-if="tabIndex==7">
      <FileManagement :quesNaireData="quesNaireData" />
    </template>
    <!-- 引入正在开发中提示框 -->
    <Product ref="product" />
  </div>
</template>
<script>
import Questionnaire from '../common/Questionnaire.vue'
import HonorInfo from '../common/HonorInfo.vue'
import Contact from '../common/Contact.vue'
import Payment from '../common/Payment.vue'
import FileManagement from '../common/FileManagement.vue'
import Product from '@/components/Product.vue'
import { time } from '@/assets/js/common'
import { getRecordList, failReason } from '@/api/index'
export default {
  data() {
    return {
      tabIndex: 0,
      activeName: '1',
      statusParams: {
        pageNumber: 1,
        pageSize: 4,
        applyStatus: '',
        sort: ''
      },
      pendingData: [],
      pendingTotal: 0,
      turnDownData: [],
      turnDownTotal: 0,
      finishedData: [],
      finishedTotal: 0,
      isRotate: false,
      reasonData: {
        comment: ""
      },
      timer: null,
      startTime: "",  // 申请开始时间
    }
  },
  created() {
    this.init()
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    async init() {
      if (this.activeName == '1') {
        this.statusParams.applyStatus = 6
        if (this.isRotate) {
          this.statusParams.sort = 'asc'
        } else {
          this.statusParams.sort = 'desc'
        }
        const { data } = await getRecordList(this.statusParams)
        if (data.code != 0) return
        this.pendingData = JSON.parse(JSON.stringify(data.applyRecordList))
        this.pendingTotal = data.total
        time(this.timer, this.pendingData, this.startTime, this);
      } else if (this.activeName == '2') {
        this.statusParams.applyStatus = 4
        if (this.isRotate) {
          this.statusParams.sort = 'asc'
        } else {
          this.statusParams.sort = 'desc'
        }
        const { data } = await getRecordList(this.statusParams)
        if (data.code != 0) return
        this.turnDownData = JSON.parse(JSON.stringify(data.applyRecordList))
        this.turnDownTotal = data.total
      } else if (this.activeName == '3') {
        this.statusParams.applyStatus = 5
        if (this.isRotate) {
          this.statusParams.sort = 'asc'
        } else {
          this.statusParams.sort = 'desc'
        }
        const { data } = await getRecordList(this.statusParams)
        if (data.code != 0) return
        this.finishedData = JSON.parse(JSON.stringify(data.applyRecordList))
        this.finishedTotal = data.total
      }
    },
    handleTabClick(tab) {
      this.activeName = tab.name
      this.statusParams.pageNumber = 1
      this.init()
    },
    pendingCurrent(page) {
      this.statusParams.pageNumber = page
      this.init()
    },
    turnDownCurrent(page) {
      this.statusParams.pageNumber = page
      this.init()
    },
    finishedCurrent(page) {
      this.statusParams.pageNumber = page
      this.init()
    },
    handleImg() {
      this.isRotate = !this.isRotate
      this.init()
    },
    async reason(id) {
      const { data } = await failReason(id)
      if (data.code != 0) return
      this.reasonData = data.applyRecord
    },
    gToQuesNare(row) {
      this.quesNaireData = row
      if (row.applyType == 1) {
        this.tabIndex = 1
      } else if (row.applyType == 2) {
        this.tabIndex = 2
      } else if (row.applyType == 3) {
        this.tabIndex = 3
      } else if (row.applyType == 4) {
        this.tabIndex = 4
      } else if (row.applyType == 5) {
        this.tabIndex = 5
      } else if (row.applyType == 6) {
        this.tabIndex = 6
      } else if (row.applyType == 7) {
        this.tabIndex = 7
      }
    },
    // 催一下
    hurryClick() {
      this.$refs.product.titleName = '催一下'
      this.$refs.product.startNavSync = true
    },
  },
  components: {
    Questionnaire,
    HonorInfo,
    Contact,
    Payment,
    FileManagement,
    Product
  }
}
</script>
<style lang='less' scoped>
#application {
  padding: 0 25px;
  /deep/.admin_content {
    .introduction {
      margin-top: 20px;
      width: 100%;
      height: 40px;
      line-height: 40px;
      background-color: #ffffff;
      padding: 0 25px;
      img {
        vertical-align: middle;
      }
      .one {
        color: #6a707e;
        img {
          margin-right: 10px;
        }
      }
      .two {
        color: #0066cc;
        text-align: right;
        img {
          margin-left: 10px;
        }
      }
      .turnDown {
        color: #f98855;
        font-size: 23px;
        vertical-align: middle;
        margin-right: 10px;
        font-weight: 550;
      }
    }
    .detail {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      // padding: 0 25px;
      margin: 25px 0;
      .detail_l {
        padding: 20px;
        background-color: #fff;
        .common {
          border-right: 1px solid #d5d5d5;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .square {
            position: relative;
            display: inline-block;
            width: 18%;
            height: 60px;
            border-radius: 5px;
            img {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .needApply {
            background-color: #dd3924;
          }
          .pending {
            background-color: #0066cc;
          }
          .finished {
            background-color: #3ee1b4;
          }
          .text {
            margin-left: 20px;
          }
          .info {
            height: 60px;
            line-height: 20px;
            margin-left: 50px;
          }
        }
        .left_four {
          position: relative;
          .quick {
            padding-left: 25px;
            font-weight: 550;
          }
          img {
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
          }
          p {
            color: #0066cc;
            cursor: pointer;
          }
        }
        .middleY {
          top: 50%;
          // left: 50%;
          transform: translateY(50%);
        }
      }
      .detail_r {
        height: 100%;
        text-align: center;
        .timeOut {
          font-weight: 550;
          color: #dd3924;
        }
        img {
          width: 20px;
          vertical-align: middle;
          margin-left: 10px;
        }
      }
    }
    /deep/.remainTips {
      .el-badge__content.is-fixed {
        top: 10px;
        right: 2px;
      }
    }
    .el-tabs__active-bar {
      width: 165px;
    }
    .el-tabs__item {
      width: 165px !important;
    }
  }
  /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #666 !important;
  }
}
</style>